module.exports = __webpack_public_path__ + "img/m1_t1_en.0f1c0424.svg";